import type { ReviewUnit } from "../../../api/content/curationApi";
import type { ReviewRequest } from "../../../api/content/reviewCollaborationApi";

/**
 * Review requests on the review page (curation-ui.md CU-10), pure: which requests concern
 * the unit in focus, and who may review which of its items, so the person asking sees whom a
 * request can hand the unit to. A request itself grants nothing.
 */

/** The conversation shows every request; a unit those for it or for the whole change set. */
export function requestsForUnit(requests: readonly ReviewRequest[], unit: ReviewUnit): readonly ReviewRequest[] {
  if (unit.kind === "conversation") {
    return requests;
  }
  return requests.filter((request) => request.unitKeys.length === 0 || request.unitKeys.includes(unit.key));
}

/** Who may review each of the unit's items, as the server answers it per item: item ID → user IDs. */
export type ItemReviewers = ReadonlyMap<string, readonly string[]>;

/** The IDs of the unit's items `userId` may review now. */
export function reviewableItemIds(reviewers: ItemReviewers, userId: string, items: ReviewUnit["items"]): readonly string[] {
  return items.filter((item) => reviewers.get(item.itemId)?.includes(userId) === true).map((item) => item.itemId);
}

/** Open requests first, newest first within each state. */
export function orderedRequests(requests: readonly ReviewRequest[]): readonly ReviewRequest[] {
  return [...requests].sort((left, right) => Number(right.state === "open") - Number(left.state === "open") || right.at.localeCompare(left.at));
}
